import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-white shadow-md sticky top-0 z-50" data-id="element-179">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center" data-id="element-180">
        <div className="flex items-center" data-id="element-181">
          <img src="https://professorpressurewashing.com/wp-content/uploads/2025/01/IMG_8776-removebg-preview-e1741153166170.png" alt="Professor Pressure Washing Logo" className="h-16" data-id="element-182" />
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8" data-id="element-183">
          <a href="#services" className="text-gray-700 hover:text-green-600 font-medium transition-colors" data-id="element-184">
            Services
          </a>
          <a href="#about" className="text-gray-700 hover:text-green-600 font-medium transition-colors" data-id="element-185">
            About
          </a>
          <a href="#testimonials" className="text-gray-700 hover:text-green-600 font-medium transition-colors" data-id="element-186">
            Testimonials
          </a>
          <a href="#contact" className="text-gray-700 hover:text-green-600 font-medium transition-colors" data-id="element-187">
            Contact
          </a>
        </nav>
        {/* Mobile menu button */}
        <button className="md:hidden text-gray-700" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-188">
          {isMenuOpen ? <XIcon size={24} data-id="element-189" /> : <MenuIcon size={24} data-id="element-190" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white px-4 py-2" data-id="element-191">
          <nav className="flex flex-col space-y-3 pb-3" data-id="element-192">
            <a href="#services" className="text-gray-700 hover:text-green-600 font-medium transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-193">
              Services
            </a>
            <a href="#about" className="text-gray-700 hover:text-green-600 font-medium transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-194">
              About
            </a>
            <a href="#testimonials" className="text-gray-700 hover:text-green-600 font-medium transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-195">
              Testimonials
            </a>
            <a href="#contact" className="text-gray-700 hover:text-green-600 font-medium transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-196">
              Contact
            </a>
          </nav>
        </div>}
    </header>;
};